<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Task Category"
      text="Edit Task Category"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localTaskPriority.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      taskPriority: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) this.localTaskPriority = { ...this.taskPriority }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            this.$api.taskPriorities().update(this.taskPriority.id, this.prepareFormData())
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.status })
                this.dialog = false
              })
          })
      },
      prepareFormData () {
        return this.localTaskPriority
      },
    },
  }
</script>
